import React from 'react';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getFinanceiroCaixa,
} from '../../security/securityContext';
import { tamanhoArquivoUpload } from '../../util/applicationContext';

export default function UploadArquivo({
                                          idEmpresa,
                                          label,
                                          nomeArquivo,
                                          urlArquivo,
                                          readOnly = false,
                                          onChange,
                                          onRemover,
                                          baixarComprovante,
                                          accept = 'image/png,image/jpeg,application/pdf'
                                      }) {
    const validarArquivo = (file) => {
        if (!/\.(jpe?g|png|pdf)$/i.test(file.name)) return false;
        if (file.size > tamanhoArquivoUpload) {
            alert('Tamanho do arquivo excede 20 MB');
            return false;
        }
        return true;
    };

    const handleChange = (event) => {
        const file = event.target.files?.[0];
        if (!file || !validarArquivo(file)) return;

        const reader = new FileReader();
        reader.onload = () => {
            onChange(file.name, reader.result);
        };
        reader.readAsDataURL(file);
    };


    const renderArquivoAtual = () => (
        <div className="row align-items-center mt-2">
            <div className="col-md-6 label-cancelamento ml-2">
                <strong>{label}:</strong>
            </div>
            <span className="mr-2">{nomeArquivo}</span>
            {urlArquivo && (
                <button type="button" className="btn btn-editar" title="Baixar" onClick={baixarComprovante}>
                    <i className="material-icons nav-icon" style={{ color: '#fa8d42' }}>&#xe2c0;</i>
                </button>
            )}
            {!readOnly && (
                <button type="button" className="btn btn-editar" title="Remover" onClick={onRemover}>
                    <i className="material-icons nav-icon" style={{ color: 'red' }}>&#xe14c;</i>
                </button>
            )}
        </div>
    );

    const renderUploadInput = () => (
        <Autorizacao perfisPermitidos={[
            getGestorEmpresa(idEmpresa),
            getAdminEmpresa(idEmpresa),
            getOperadorEmpresa(idEmpresa),
            getFinanceiroCaixa(idEmpresa),
        ]}>
            <div className="input-wrapper mt-4">
                <label className="btn-laranja" htmlFor={`input-file-${label.toLowerCase().replace(/\s/g, '-')}`}>
                    <div className="row align-items-center">
                        <i className="material-icons aberto">&#xe2c3;</i>
                        <strong className="ml-2">Anexar {label}</strong>
                    </div>
                </label>
                <input
                    id={`input-file-${label.toLowerCase().replace(/\s/g, '-')}`}
                    type="file"
                    accept={accept}
                    onChange={handleChange}
                    style={{ display: 'none' }}
                />
            </div>
        </Autorizacao>
    );

    return (
        <>
            {(nomeArquivo || urlArquivo) ? renderArquivoAtual() : null}
            {!readOnly && renderUploadInput()}
        </>
    );
}
